export enum LocalMessageDescribeModeType {
  Push = 'push',
  Update = 'update',
  Collapse = 'collapse',
  // the card came back from the overflow pill
  Surface = 'surface',
}
